import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import moment from "moment";
import { Paper } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import Header from "../../customerpanel/components/Header";
import { Container, Row } from "react-bootstrap";

const CutomerTurbine = () => {
  const [loading, setLoading] = useState(true);
  const [turbine, setTurbine] = useState([]);

  const [isLoggedIn, setIsLoggedIn] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const customerId = localStorage.getItem("customerId");
      //  const customerId = "520cdd307940c5968fddd52a61d08bdb";
        const response = await fetch(
          "https://api.srivarugreenenergy.com/customerapi/customerturbine/list.php",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ user_id: customerId }),
          },
        );

        if (!response.ok) throw new Error("Failed to fetch data");

        const responseData = await response.json();
        setLoading(false);
        if (responseData.status === 200) {
          setTurbine(responseData.data);
        } else {
          throw new Error(responseData.msg);
        }
      } catch (error) {
        setLoading(false);
        console.error("Error fetching data:", error.message);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    // const session = localStorage.getItem("session");
    // setIsLoggedIn(!!session);
    setIsLoggedIn(true);
  }, []);

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  const columns = [
    { field: "id", headerName: "S.No", width: 70 },
    { field: "wtg_no", headerName: "WEG No.", width: 130 },
    { field: "customer_name", headerName: "Customer Name", width: 180 },
    { field: "loc_no", headerName: "Loc. No", width: 130 },
    { field: "htsc_no", headerName: "HTSC NO", width: 130 },
    { field: "doc", headerName: "DOC", width: 130 },
    { field: "site_name", headerName: "Site", width: 150 },
    { field: "location_name", headerName: "Place", width: 150 },
    { field: "model_type", headerName: "Model", width: 130 },
    { field: "capacity", headerName: "Capacity", width: 130 },
    { field: "tower_ht", headerName: "Tower Ht", width: 130 },
    { field: "contract_code", headerName: "Contract Type", width: 180 },
    { field: "feeder_voltage", headerName: "Feeder Voltage", width: 180 },
    { field: "feed_name", headerName: "Feeder Name", width: 180 },
    { field: "sub_station", headerName: "Substation", width: 180 },
    {
      field: "file_name",
      headerName: "File Name",
      width: 200,
      renderCell: (params) => {
        const pdfFiles = params.row.pdf_files;
        return pdfFiles.length > 0
          ? pdfFiles.map((file, index) => (
            <a
              key={index}
              href={`https://api.srivarugreenenergy.com/uploads/${file.pdf_id}_${file.fileName}`}
              target="_blank"
              rel="noopener noreferrer"
              style={{ marginRight: 5 }}
            >
              {file.fileName}
            </a>
          ))
          : "No File";
      },
    },
    { field: "doc_date", headerName: "DOC Date", width: 150 },
  ];

  const rows = turbine.map((item, index) => ({
    id: index + 1,
    wtg_no: item.wtg_no,
    customer_name: item.customer_name,
    loc_no: item.loc_no,
    htsc_no: item.htsc_no,
    doc: moment(item.date).format("DD-MM-YYYY"),
    site_name: item.site_name,
    location_name: item.location_name,
    model_type: item.model_type,
    capacity: item.capacity,
    tower_ht: item.tower_ht,
    contract_code: item.contract_code,
    feeder_voltage: item.feeder_voltage,
    feed_name: item.feed_name,
    sub_station: item.sub_station,
    pdf_files: item.pdf_files || [],
    doc_date:
      item.pdf_files
        ?.map((file) => moment(file.pdf_date).format("DD-MM-YYYY"))
        .join(", ") || "No Date",
  }));

  return (
    <div id="main" className="noselect">
      <Header />
      <Container fluid className="main my-3 p-3">
        <Row>
          <Paper sx={{ height: 600, width: "100%" }}>
            <DataGrid
              rows={rows}
              columns={columns}
              pageSize={10}
              rowsPerPageOptions={[5, 10, 20]}
              disableSelectionOnClick
              loading={loading}
            />
          </Paper>
        </Row>
      </Container>
    </div>
  );
};

export default CutomerTurbine;
